import React, { createContext, useState, useContext, useEffect } from 'react';
import {NotificationManager} from "react-notifications";

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

const isTokenExpired = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        const payload = JSON.parse(window.atob(base64));

        const currentTime = Date.now() / 1000; // Convert to seconds
        if (payload.exp < currentTime) {
            // Token has expired
            return true;
        }
        return false;
    } catch (error) {
        console.error("Invalid token", error);
        return true;
    }
};

export function AuthProvider({ children }) {
    const [auth, setAuth] = useState({
        token: localStorage.getItem('authToken'),
        roles: JSON.parse(localStorage.getItem('roles')),
    });

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    // const refreshTokenBasedOnActivity = () => {
    //     // Refresh the token if there is any user activity
    //     const token = localStorage.getItem('authToken');
    //     if (token && isTokenAboutToExpire(token)) {
    //         refreshToken();  // Replace with your actual refresh token logic
    //     }
    // };

    useEffect(() => {
        setIsAuthenticated(!!auth.token);
        setIsAuthorized(auth.roles?.includes('ROLE_ADMIN'));
        // Poarta pentru meniul "Rapoarte". Doar cosmetica: endpoint-urile
        // /api/v1/admin/* verifica rolul si pe server.
        setIsSuperAdmin(!!auth.roles?.includes('ROLE_SUPER_ADMIN'));
        console.log(auth);

        // Check token expiration at regular intervals
        const intervalId = setInterval(() => {
            const token = localStorage.getItem('authToken');
            if (token && isTokenExpired(token)) {
                NotificationManager.error('Your session expired! Please login again!')
                console.log('Token has expired');
                localStorage.removeItem('authToken');
                localStorage.removeItem('roles');
                setAuth({ token: null, roles: null });
            }
        }, 1000 * 60); // Check every minute

        return () => clearInterval(intervalId);

    }, [auth]);

    const setAuthData = (token, roles) => {
        if (!isTokenExpired(token)) {
            localStorage.setItem('authToken', token);
            localStorage.setItem('roles', JSON.stringify(roles));
            setAuth({token, roles});
        }
    };

    const logout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('roles');
        setAuth({ token: null, roles: null });
        NotificationManager.info('Successfully logout!')
    };

    return (
        <AuthContext.Provider value={{ auth, setAuthData, isAuthenticated, isAuthorized, isSuperAdmin, logout }}>
            {children}
        </AuthContext.Provider>
    );
}
